import { render, staticRenderFns } from "./SupplierQC.vue?vue&type=template&id=5663470f&scoped=true"
import script from "./SupplierQC.vue?vue&type=script&lang=js"
export * from "./SupplierQC.vue?vue&type=script&lang=js"
import style0 from "./SupplierQC.vue?vue&type=style&index=0&id=5663470f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5663470f",
  null
  
)

export default component.exports